// @flow
import { v4 as uuidv4 } from 'uuid';

function addIdToList(list: Array<any>, propName: string): Array<any> {
	return list.map(obj => ({ [propName || 'id']: uuidv4(), ...obj }));
}

export default addIdToList;
